/**
 * Composition method for gallery header
 * 
 * Author: Andrea López
 */

import { computed, ref } from 'vue';
import { getLyraEndpoints } from '@/core/modules/lyra/services';

/**
 * Method to derive data for section links
 */
export function dataComposition () {
	// Computed sections data
	const sections = computed((): any[] => {
		return getLyraEndpoints('sections');
	});

	return { sections }
}

/**
 * Additional buttons composition
 */
export function additionalButtonsComposition () {
	// Data members
	const additionalButtons = [
		{
			buttonId: 'fact-sheet',
			type: 'external',
			url: 'https://labeling.pfizer.com/ShowLabeling.aspx?id=16474'
		}
	];

	function processButton (url: string) {
		window.open(url);
	}

	return { additionalButtons, processButton }
}

/**
 * Hamburger menu composition
 */
export function menuComposition () {
    const isMenuActive = ref<boolean>(false);
    
    function toggleMenu () {
        isMenuActive.value = !isMenuActive.value;
    }
    
    const menuIcon = computed(() => {
        return isMenuActive.value ? 'close' : 'hamb-icon';
    });

    return {
        toggleMenu, isMenuActive, menuIcon
    }
}
